import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "space-y-1"
}
const _hoisted_2 = { class: "flex-1" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6 6L14 10L6 14V6Z",
  fill: "currentColor"
}, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = {
  key: 0,
  class: "space-y-1"
}
const _hoisted_6 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!

  return (!_ctx.innerItem.children)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('item-clicked', _ctx.item))),
        class: _normalizeClass(['group flex innerItems-center px-2 py-2 text-sm font-medium rounded-md hover:cursor-pointer',
                   _ctx.innerItem.current ? 'bg-app-theme-700 text-white' : 'text-gray-100 hover:bg-app-theme-500'])
      }, [
        (_ctx.innerItem.icon)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.innerItem.icon), {
              key: 0,
              class: "mr-3 h-6 w-6 flex-shrink-0 text-gray-300",
              "aria-hidden": "true"
            }))
          : (_ctx.innerItem.faIcon)
            ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                key: 1,
                icon: _ctx.innerItem.faIcon,
                class: "ml-0.5 mr-3 w-5 h-5 text-gray-300"
              }, null, 8, ["icon"]))
            : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.innerItem.name), 1)
      ], 2))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.innerItem.open = !_ctx.innerItem.open)),
          class: _normalizeClass([_ctx.innerItem.current ? 'bg-app-theme-700 text-white' : 'text-gray-100 hover:bg-app-theme-500',
                      'group w-full flex innerItems-center pl-2 pr-1 py-2 text-left text-sm font-medium rounded-md cursor-pointer'])
        }, [
          (_ctx.innerItem.icon)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.innerItem.icon), {
                key: 0,
                class: "mr-3 h-6 w-6 flex-shrink-0 text-gray-300"
              }))
            : (_ctx.innerItem.faIcon)
              ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                  key: 1,
                  icon: _ctx.innerItem.faIcon,
                  class: "ml-0.5 mr-3 w-5 h-5 text-gray-300"
                }, null, 8, ["icon"]))
              : _createCommentVNode("", true),
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.innerItem.name), 1),
          (_openBlock(), _createElementBlock("svg", {
            class: _normalizeClass([_ctx.innerItem.open ? 'rotate-90' : '', 'ml-3 h-5 w-5 flex-shrink-0 transform transition-colors duration-150 ease-in-out text-gray-200']),
            viewBox: "0 0 20 20",
            "aria-hidden": "true"
          }, _hoisted_4, 2))
        ], 2),
        (_ctx.innerItem.open)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.innerItem.children, (subItem) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: subItem.name,
                  onClick: ($event: any) => (_ctx.$emit('item-clicked', subItem)),
                  class: _normalizeClass(['group text-white flex w-full items-center rounded-md py-2 pl-11 pr-2 text-sm font-medium cursor-pointer hover:bg-app-theme-500',
                         subItem.current ? 'bg-app-theme-700' : ''])
                }, [
                  (subItem.icon)
                    ? (_openBlock(), _createBlock(_resolveDynamicComponent(subItem.icon), {
                        key: 0,
                        class: "mr-3 h-6 w-6 flex-shrink-0 text-gray-300",
                        "aria-hidden": "true"
                      }))
                    : (subItem.faIcon)
                      ? (_openBlock(), _createBlock(_component_FontAwesomeIcon, {
                          key: 1,
                          icon: subItem.faIcon,
                          class: "ml-0.5 mr-3 w-5 h-5 text-gray-300"
                        }, null, 8, ["icon"]))
                      : _createCommentVNode("", true),
                  _createTextVNode(" " + _toDisplayString(subItem.name), 1)
                ], 10, _hoisted_6))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]))
}